import React, { useState } from 'react';
import LaunchTokenModal from '../../components/modal/LaunchTokenModal';
import './TokenLaunchStyles.scss';

const launchedTokens = [
  {
    name: 'Token XYZ',
    symbol: 'XYZ',
    recentMiningWinner: 'SP123...4WXYZ',
    currentMiningReward: '3200',
    activeCycle: '5',
    stackingStatsAtCycle: '100000',
    explorerContract: 'https://explorer-url.com/contract-xyz',
  },
  {
    name: 'Token ABC',
    symbol: 'ABC',
    recentMiningWinner: 'SP789...0ABCD',
    currentMiningReward: '1000',
    activeCycle: '0',
    stackingStatsAtCycle: '650510',
    explorerContract: 'https://explorer-url.com/contract-abc',
  },
];

const TokenLaunchPad = () => {
  // State for sorting: column and order
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'ascending' });
  const [isModalOpen, setIsModalOpen] = useState(false); // State to manage modal visibility

  // Function to sort data based on the selected column
  const sortedTokens = [...launchedTokens].sort((a, b) => {
    if (sortConfig.key) {
      let aValue = a[sortConfig.key];
      let bValue = b[sortConfig.key];

      // Convert string numbers to actual numbers for sorting purposes if needed
      if (!isNaN(aValue) && !isNaN(bValue)) {
        aValue = Number(aValue);
        bValue = Number(bValue);
      }

      if (aValue < bValue) {
        return sortConfig.direction === 'ascending' ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === 'ascending' ? 1 : -1;
      }
    }
    return 0;
  });

  // Function to request sorting based on column key
  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  // Function to open the modal
  const openModal = () => {
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="launch-pad">
      {/* 1. Intro */}
      <section className="launch-intro" style={{ backgroundImage: `url(/launchpad-banner.png)`, backgroundSize: 'cover', height: '15rem' }}>
        {/* <h1>Welcome to the Derupt Token Launch Pad</h1> */}
        {/* <p>Launch your token with our unique integrated social experience!</p> */}
      </section>

      {/* 2. How to Launch */}
      <section className="how-to-launch">
        <h2>Start Your Token in 3 Easy Steps:</h2>
        <p>Step 1: Supply Token Details</p>
        <p>Step 2: Deploy Contracts</p>
        <p>Step 3: Activate</p>
        <small>We believe in launching fairly.</small>
        <br />
        <small>We do not collect STX to launch</small>
        <br />
        <small>We do not collect any of your tokens to launch</small>
      </section>

      {/* 3. How it Works */}
      <section className="how-it-works">
        <h2>How does it work?</h2>
        <p>After launch, users can mine, stack, and transfer your token directly within Derupt.</p>
        <small>
          Launched Tokens are PoX-Lite SIP10 compatible to ensure 3rd-party apps can integrate
        </small>
      </section>

      {/* Button to Open the Form Modal */}
      <button className="launch-button" onClick={openModal}>
        Start Your Token Launch
      </button>

      {/* 4. Display Launched Tokens with Sorting */}
      <section className="launched-tokens">
        <h2>Recently Launched Tokens</h2>
        <table className="token-table">
          <thead>
            <tr>
              <th onClick={() => requestSort('activeCycle')}>Cycle</th>
              <th onClick={() => requestSort('name')}>Name</th>
              <th onClick={() => requestSort('symbol')}>Symbol</th>
              <th onClick={() => requestSort('recentMiningWinner')}>Recent Miner</th>
              <th onClick={() => requestSort('currentMiningReward')}>Subsidy</th>
              <th onClick={() => requestSort('stackingStatsAtCycle')}>Stacked</th>
              <th>Explorer Link</th>
            </tr>
          </thead>
          <tbody>
            {sortedTokens.map((token, index) => (
              <tr key={index}>
                <td>{token.activeCycle}</td>
                <td>{token.name}</td>
                <td>{token.symbol}</td>
                <td>{token.recentMiningWinner}</td>
                <td>{token.currentMiningReward}</td>
                <td>{token.stackingStatsAtCycle}</td>
                <td>
                  <a href={token.explorerContract} target="_blank" rel="noopener noreferrer">
                    View Contract
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      {/* LaunchTokenModal with visibility controlled by state */}
      {isModalOpen && <LaunchTokenModal show={isModalOpen} close={closeModal} />}
    </div>
  );
};

export default TokenLaunchPad;
